import React from "react";
import { Redirect } from "react-router-dom";
//
import LoginPage from "../Login";
import AuthRouter from "../Auth";
import { ErrorMaintenance, ErrorOffline } from "../Errors";
import DashboardLayout from "../Dashboard";
//
import {
  ROUTE_LOGIN,
  ROUTE_AUTH,
  ROUTE_DASHBOARD,
  ROUTE_ERR_MAINTENANCE,
  ROUTE_ERR_OFFLINE,
} from "fixtures/routes";

// list of main app routes
const routes = [
  {
    path: "/",
    exact: true,
    main: () => <Redirect to={`/${ROUTE_DASHBOARD}`} />,
    isProtected: true,
  },
  {
    path: `/${ROUTE_DASHBOARD}`,
    main: () => <DashboardLayout />,
    isProtected: true,
  },
  {
    path: `/${ROUTE_LOGIN}`,
    exact: true,
    main: () => <LoginPage />,
  },
  {
    path: `/${ROUTE_AUTH}`,
    main: () => <AuthRouter />,
  },
  {
    path: `/${ROUTE_ERR_MAINTENANCE}`,
    main: () => <ErrorMaintenance />,
  },
  {
    path: `/error-maintenance`,
    main: () => <ErrorMaintenance />,
  },
  {
    path: `/${ROUTE_ERR_OFFLINE}`,
    main: () => <ErrorOffline />,
  },
];

export default routes;
